import { h } from 'preact';

export default props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
		<path d="M5.83317 17.2188C3.34233 15.7779 1.6665 13.0848 1.6665 10.0003C1.6665 5.39795 5.39746 1.66699 9.99984 1.66699C14.6022 1.66699 18.3332 5.39795 18.3332 10.0003C18.3332 13.0848 16.6573 15.7779 14.1665 17.2188M13.3332 10.0004L9.99984 6.66705M9.99984 6.66705L6.6665 10.0004M9.99984 6.66705V18.3337" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);